<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.material_stations')"/>

        <material-station-search class="my-2" @search="fetchStations"/>

        <div class="col-sm-12 pb-3">
          <!-- Add button-->
          <div
            v-if="isObserver"
            class="data-list-item add"
            @click.stop="addNew"
          >
            <div class="item-img-cont add-title">
              <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
              <span class="item-title-add">{{ $t('common.add_new') }}</span>
              <font-awesome-icon
                icon="lock"
                class="card-body-icon"
              />
            </div>
          </div>
          <material-station-list
            :stations="stations"
            @row-clicked="editStation"
          />
        </div>

        <!-- Editor-->
        <material-station-modal
          v-model="station"
          :is-observer="isObserver"
          @cancel="station = null"
          @close-and-update="closeAndUpdate"
        />

        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import MaterialStationSearch from "@/components/materials/station/MaterialStationSearch";
import MaterialStationList from "@/components/materials/station/MaterialStationList";
import MaterialStationModal from "@/components/materials/station/MaterialStationModal";
import {workManagementHelper} from "@/components/mixins/WorkManagementMixin";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'MaterialStations',
    components: {
        Navbar,
        MaterialStationModal,
        MaterialStationList,
        MaterialStationSearch
    },
    mixins: [restApi, workManagementHelper],
    props: {
        isObserver: {
            type: Boolean,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            stations: [],
            station: null
        }
    },
    created: function () {
        this.fetchStations()
    },
    methods: {
        fetchStations: function (params) {
            this.loading = true
            this.restFetchParams(this.materialStationUrl, params, this.handleResponse, this.onError)
        },
        handleResponse: function (response) {
            this.stations = response.data
            this.loading = false
        },
        onError: function () {
            this.loading = false
            this.stations = []
        },
        editStation: function (station) {
            if (this.isObserver) {
                this.station = station
                this.editMode = true
            }
        },
        closeAndUpdate: function () {
            this.station = null
            this.stations = []
            this.fetchStations()
        },
        addNew: function () {
            this.station = this.newMaterialStation()
        }
    }
}
</script>
